import { Box, styled } from '@mui/material';

export const ContainerStyled = styled(Box)(() => ({
  width: '100%',
}));
